export default __webpack_public_path__ + "static/media/product-3.97a9a3f5.jpg";